import { useSearchContext } from '@jane/search/hooks';
import type { ProductCardWithTrackingProps } from '@jane/shared-ecomm/components';
import { ProductCardWithTracking } from '@jane/shared-ecomm/components';
import { useMenu, useSpecials } from '@jane/shared-ecomm/providers';

type MenuProductCardProps = Pick<
  ProductCardWithTrackingProps,
  | 'algoliaIndexName'
  | 'appliedWeightFilter'
  | 'breadcrumbs'
  | 'cardIndex'
  | 'carouselView'
  | 'columnPosition'
  | 'disableWeightFilter'
  | 'maxWeightOption'
  | 'menuRowName'
  | 'product'
  | 'productLocation'
  | 'rowPosition'
  | 'showOnlyWeights'
  | 'weightFilter'
  | 'withoutDrawerOnAddToCart'
  | 'isMenuTopRow'
>;

export const MenuProductCard = (props: MenuProductCardProps) => {
  const { searchState } = useSearchContext();

  const {
    appInfo: { appMode },
    cart,
    dispatches: { attemptToAddToCart, closeCart, deleteCartItem },
    listView,
    paths,
    store,
    jdid,
  } = useMenu();

  const { specials } = useSpecials();

  const cartIsOpen = Boolean(cart.is_open);
  const cartProducts = cart.products;
  const cartStoreId = cart.store?.id;

  return (
    <ProductCardWithTracking
      appMode={appMode}
      attemptToAddToCart={attemptToAddToCart}
      cartIsOpen={cartIsOpen || false}
      cartProducts={cartProducts}
      cartStoreId={cartStoreId}
      closeCart={closeCart}
      deleteCartItem={deleteCartItem}
      janeDeviceId={jdid}
      listView={listView}
      pdpPath={paths.menuProduct}
      searchState={searchState}
      specials={specials}
      store={store}
      {...props}
    />
  );
};
